<footer>
    <p>Copyright &copy; 2023-{{year}} - Dominion Athletica - All Rights Reserved.</p>
</footer>